module.exports = __webpack_public_path__ + "img/x256.364a9bd9.png";